// 正则表达式
export const constant = {
    waybillNoRegular: () => {
        return /^[A-Za-z0-9]{10,13}$|^[6-9][0-9]{17}$|^[Dd]{2}[8-9][0-9]{15}$|^(Y|y)[0-9]{12}$|^(G|g)8[0-9]{16}$|^(M|m)[0-9]{14}$|^(Y|y)(T|t)[0-9a-zA-Z]{13}$/;
    },
    mobileRegular: () => {
        return /^1\d{10}$/;
    },
    orderNoRegular: () => {
        return /^(TW|tw)[0-9]{13}$|^(TW|tw)[0-9]{12}[A-Za-z]{1}$|^(TW|tw)[A-Za-z0-9]{13}$|^(BG|bg)[0-9]{13}$|^(FS|fs)[0-9]{19}$|^(SL101LST|sl101lst)[0-9]{19}$|^(ST|st)[0-9]{16}$|^(WJD|wjd)[0-9]{9}$|^(d|D)[0-9]{10,11}$|^(WOSP|wosp)[0-9]{12}(FRA|fra)$|^[A-Za-z]{2}[0-9]{14}$/;
    },
    verifyCaptcha: () => {
        return /^[0-9a-zA-Z]{6}$/g;
    }
};



// WEBPACK FOOTER //
// ./src/common/publicConstant.js